import clsx from 'clsx';

import * as DropdownMenu from '@app/components/dropdown-menu-v2';
import FolderIcon from '@app/components/icons/folder';

import type { BreadCrumbLink } from './types';
import style from './bread-crumb-dropdown.module.scss';

type Props = {
  links: BreadCrumbLink[];
  onDropdownItemClick?: (id?: number) => void;
  DropdownItemClassName?: string;
};

export const BreadCrumbDropdown = ({
  links,
  onDropdownItemClick,
  DropdownItemClassName,
}: Props) => {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger className={style.BreadCrumbDropdown}>...</DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content sideOffset={5}>
          {links.map((folder) => (
            <DropdownMenu.Item
              className={clsx(style.BreadCrumbDropdownItem, DropdownItemClassName)}
              onSelect={() => onDropdownItemClick?.(folder.id)}
              key={folder.id}
            >
              <FolderIcon
                width="14px"
                height="14px"
              />
              <span>{folder.label}</span>
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};
